import { Col, Form, Input, Row } from 'ui';

export type MemberCommunitiesListFiltersFormValues = {
  search?: string;
};

const MemberCommunitiesListFilters = () => (
  <Row>
    <Col span={24}>
      <Form.Item<MemberCommunitiesListFiltersFormValues> label="Search" name="search">
        <Input hasSearch />
      </Form.Item>
    </Col>
  </Row>
);

export default MemberCommunitiesListFilters;
